import useTranslate from 'modules/local/useTranslate'
import React, {useMemo, useState} from 'react'
import {NullAsDefault} from 'views/Shared'
import {notifyOnError} from "../../factory/createErrorEvent";
import {bindQueryParams} from "../../functions/routerHelper";
import {NotificationActionTypes, successNotify} from "../../factory/createNotification";
import useAsyncAction from "../../../../modules/asyncCache/useAsyncAction";
import CRUD from "../../../Shared/enums/CRUD";
import {Modal} from "antd";
import {DelayRender} from "../../../Discovery/DelayRender";
import {
    catholicHousehold_createHouseholdMember_Api,
    catholicHousehold_deleteHouseholdMember_Api,
    catholicHousehold_updateHouseholdMember_Api
} from "../../../../apis/catholicHousehold";
import CatholicHouseholdContext, {CatholicHouseholdProvider} from "../CatholicHouseholdContext";
import {DetailViewForm} from "../components/CatholicHouseholdMemberForm";
import LoadingBlock from "../../../LoadingBlock";


export const useCatholicHouseholdMembers = ({
                                                catholic_household_id = undefined,
                                                notifyListeners = {
                                                    onCreated: undefined,
                                                    onUpdated: undefined,
                                                    onDeleted: undefined,
                                                },
                                            }) => {
    const t = useTranslate()
    const [action, setAction] = useState({type: undefined, value: undefined})

    const {
        onCreated = NullAsDefault,
        onUpdated = NullAsDefault,
        onDeleted = NullAsDefault,
    } = notifyListeners ?? {}

    const onError = notifyOnError(t)

    const {handleAsyncAction: onCreate, ...asyncCreating} = useAsyncAction({
        onError,
        query: bindQueryParams([{id: catholic_household_id}]),
        apiInfo: catholicHousehold_createHouseholdMember_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.CREATE, t)
            onCreated(result, data)
        },
    })

    const {handleAsyncAction: onUpdate, ...asyncUpdating} = useAsyncAction({
        onError,
        apiInfo: catholicHousehold_updateHouseholdMember_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onUpdated(result, data)
        },
    })

    const {handleAsyncAction: onDelete, ...asyncDeleting} = useAsyncAction({
        onError,
        apiInfo: catholicHousehold_deleteHouseholdMember_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.DELETE, t)
            onDeleted(result, data)
        },
    })

    const handleAction = (action, params) => {
        switch (action) {
            case CRUD.READ:
                setAction({type: action, value: params})
                break
            default:
                break
        }
    }
    const onCancel = () => {
        setAction({})
    }
    const showDialog = (params) => {
        return handleAction(CRUD.READ, params)
    }

    const detailViewModal = useMemo(() => {
        let Content = NullAsDefault
        let Wrapper = ({children}) => children({initialValues: {}})
        let params = {initValues: {...action.value}}
        let modal_params = {}
        switch (action.type) {
            case CRUD.READ:
                params = {}
                modal_params = {
                    width: 600,
                    title: (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('church information')}
                        </div>
                    ),
                }
                Content = ({...rest}) => (
                    <CatholicHouseholdProvider item={action.value}>
                        <CatholicHouseholdContext.Consumer>
                            {({item}) => {
                                return (
                                    <DetailViewForm
                                        {...rest}
                                        item={item}
                                        reportAccess={false}
                                    />
                                )
                            }}
                        </CatholicHouseholdContext.Consumer>
                    </CatholicHouseholdProvider>
                )
                break
            default:
                break
        }

        return (
            <Modal
                className="custom-modal"
                footer={null}
                onCancel={onCancel}
                open={action.type && action.type !== CRUD.DELETE}
                destroyOnHidden={true}
                {...modal_params}>
                <DelayRender lazy={true}>
                    <Wrapper>
                        {({isLoading, initialValues}) => {
                            if (!!isLoading) {
                                return <LoadingBlock/>
                            }
                            return (
                                <Content
                                    {...{
                                        onCancel,
                                        item: action.value,
                                    }}
                                    {...params}
                                    initialValues={initialValues}
                                />
                            )
                        }}
                    </Wrapper>
                </DelayRender>
            </Modal>
        )
    }, [action])

    return {
        onCreate,
        onUpdate,
        onDelete,
        asyncCreating,
        asyncUpdating,
        asyncDeleting,
        detailViewModal,
        showDialog
    }
}



